<div class="input-group flex-nowrap" *ngIf="!isDisabled">
  <span class="input-group-text"><i class="bi {{ iconClass }}"></i> </span>
  <input [(ngModel)]="localValue" (ngModelChange)="onValueChange($event)" type="time" class="form-control form-control-lg"
    placeholder="{{ placeholder }}" />
</div>

<div class="input-group flex-nowrap disabled" *ngIf="isDisabled">
  <span class="input-group-text"><i class="bi {{ iconClass }}"></i> </span>
  <input [(ngModel)]="localValue" disabled="true" type="time" class="form-control form-control-lg input-border"
    placeholder="{{ placeholder }}" />
</div>
